import React, { Component } from "react";

let AllUnits = class Unit extends Component{
  render(){
    return <div>This is all unit</div>
  }
}

export default AllUnits;


// WEBPACK FOOTER //
// ./src/containers/application/AllUnits.js